import React, { Fragment } from 'react'
import {
    List,
    Datagrid,
    BooleanField,
    TextField,
    DateField,
    ReferenceField
} from 'react-admin'

import Title from '../Generic/Title'

export const NotificationList = ({ permissions, ...props }) => {
    if (permissions === null || permissions.role !== 'admin') {
        return null
    }
    return (
        <Fragment>
            <Title title={"Notificaciones"} />
            <List {...props} exporter={false} >
                <Datagrid rowClick="edit">
                    <TextField source="comment" label="Comentario"/>
                    <BooleanField  source="is_public_visible" label="Visible en Público"/>
                    <DateField source="created_date" label="Fecha Creación" showTime  />
                    <DateField source="edited_date" label="Fecha Edición" showTime  />
                    <ReferenceField source="user" reference="usuarios-coordinador" label="Usuario">
                        <TextField source="username" />
                    </ReferenceField>
                </Datagrid>
            </List>
        </Fragment>
    )
}
